/**
 * The rule for a click on a bay column of the Resource Calendar.
 */
import { UserContextType } from "app/contexts/UserContext";
import {
  BayRef,
  OptionBays,
  canBookCustomSession,
  defaultRateForBay,
} from "app/routes/Calendar/EventForm/resourceChoice";

interface BayClickParams {
  // The coach of the coach column. The new lesson goes to this coach.
  compareCoach: { id: string } | null | undefined;
  user: UserContextType;
  // The booking options a new lesson of that coach can take.
  lessonRates: OptionBays[] | null | undefined;
  bay: BayRef | null | undefined;
}

/**
 * Tells if a click on a bay can open the lesson form.
 *
 * - The coach column must show a coach.
 * - A user who cannot book a custom lesson (a scheduler, or a coach who books
 *   for another coach) books a bay through an option only. With no option
 *   that includes the bay, the click opens nothing.
 *
 * The role rules of the coach column (time, availability) apply after this.
 */
export function canOpenLessonOnBay({
  compareCoach,
  user,
  lessonRates,
  bay,
}: BayClickParams): boolean {
  if (!compareCoach || !bay) {
    return false;
  }

  if (canBookCustomSession(user, compareCoach.id)) {
    return true;
  }

  return defaultRateForBay(lessonRates, bay) !== null;
}

